// This is used for collections and search pages.

import { cacheDom } from '../utils/QuerySelectors.js'
import { setupPaginations } from '../components/Pagination.js'
import { initWishlist, privatePrices } from '../utils/helpers.js'
import { GTM_plpViewItems } from '../utils/Gtm.js'

const dom = {}
const qs = {
  section: 'data-products-grid-wrapper',
  filterBtn: 'data-filter-btn',
  plpPaginator: 'data-plp-paginator',
  plpPaginationNav: 'data-pagination-nav',
  count: 'data-plp-count',
  productsGrid: 'data-products-grid',
  // filterPanel: 'data-filter-panel',
  // sortPanel: 'data-sort-panel',
  clearAll: 'data-fs-clear-all',
  fsPanel: 'data-fs-panel',
  fsPanelInner: 'data-fs-panel-inner',
  fsPanelWrapper: 'data-fs-panel-wrapper',
  fsPanelClose: 'data-fs-panel-close',
  filterSelectsWrapper: 'data-filter-selects-wrapper',
}

const qsAll = {
  facets: 'data-facet',
  sortOptions: 'data-sort-option',
  selectedFilters: 'data-filter-selected',
  videos: 'data-plp-video',
}

const state = {
  facets: [],
  clearAll: null,
  sortOptions: [],
  selectedFilters: [],
}

const initSwipers = () => {
  const swipers = document.querySelectorAll('[data-product-card-swiper]:not(.swiper-initialized)')
  swipers.forEach((slider) => {
    new Swiper(slider, {
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
    })
  })
}

const fetchResults = (url) => {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      dom.plpPaginator.innerHTML = html.querySelector(`[${qs.plpPaginator}]`).innerHTML
      if(dom.plpPaginationNav) dom.plpPaginationNav.innerHTML = (html.querySelector(`[${qs.plpPaginationNav}]`)) ? html.querySelector(`[${qs.plpPaginationNav}]`).innerHTML : ''

      dom.fsPanelWrapper.innerHTML = html.querySelector(`[${qs.fsPanelWrapper}]`).innerHTML
      if (dom.count) dom.count.innerHTML = html.querySelector(`[${qs.count}]`).innerHTML
      state.facets = Array.from(document.querySelectorAll(`[${qsAll.facets}]`))
      state.clearAll = document.querySelector(`[${qs.clearAll}]`)
      state.sortOptions = Array.from(document.querySelectorAll(`[${qsAll.sortOptions}]`))

      dom.filterSelectsWrapper.innerHTML = html.querySelector(`[${qs.filterSelectsWrapper}]`).innerHTML
      state.selectedFilters = Array.from(document.querySelectorAll(`[${qsAll.selectedFilters}]`))

      window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
      window.setupApiTiles(dom.plpPaginator)


      initFacets()
      initWishlist()
      privatePrices()
      setupPaginations()
      document.dispatchEvent(new Event('PLPFilteredResultsLoaded'))
    })
}

const renderFilterResults = (e) => {
  const selectedFacets = state.facets
    .filter((facet) => facet.checked)
    .map((facet) => `${facet.name}=${encodeURIComponent(facet.value)}`)
    .join('&')

  if(e.currentTarget && e.currentTarget.dataset?.sortOption != undefined) {
    const selectedSortOption = state.sortOptions.find((option) => option.checked)

    Shopify.analytics.publish('gtm_sort_preference',{
      sort: selectedSortOption.value,
    });

  } else if(e.currentTarget && e.currentTarget.dataset?.facet != undefined) {

    const selectedFacetsGTM = state.facets
    .filter((facet) => facet.checked)
    .map((facet) => `${facet?.dataset?.filterLabel}:${facet?.dataset?.filterValue}`)
    .join(',')

    Shopify.analytics.publish('gtm_filters_usage',{
      filters: selectedFacetsGTM,
    });
  }

  const prevUrl = `${dom.productsGrid.dataset.productsGrid}${dom.productsGrid.dataset.productsGrid.includes('?') ? '&' : '?'}${selectedFacets}${dom.fsPanel.querySelector('input[name="sort_by"]:checked') ? '&sort_by=' + dom.fsPanel.querySelector('input[name="sort_by"]:checked').value : ''}`
  const filterUrl = `${prevUrl}&section_id=${dom.productsGrid.dataset.sectionId}`
  history.pushState({}, '', prevUrl)
  fetchResults(filterUrl)
}

const initFacets = () => {
  if (state.clearAll) {
    state.clearAll.addEventListener('click', () => {
      state.facets.forEach((facet) => (facet.checked = false))
      state.sortOptions.forEach((sortOption) => (sortOption.checked = false))
      renderFilterResults()
    })
  }

  state.facets.forEach((facet) => facet.addEventListener('input', renderFilterResults))
  state.sortOptions.forEach((option) => option.addEventListener('input', renderFilterResults))
  state.selectedFilters.forEach((selectedFilter) => {
    selectedFilter.addEventListener('click', () => {
      const prevUrl = selectedFilter.dataset.url
      const filterUrl = `${prevUrl}${ !!prevUrl && prevUrl.includes('?') ? '' : '?' }&section_id=${dom.productsGrid.dataset.sectionId}`
      history.pushState({}, '', prevUrl)
      fetchResults(filterUrl)
    })
  })
  initSwipers()
}

const toggleFilterPanel = (toggle=true) => {
  const focusableElements = Array.from(dom.fsPanel.querySelectorAll('a, button, input'))
  if(toggle) {
    dom.fsPanel.classList.remove('-z-1', 'opacity-0')
    dom.fsPanel.classList.add('z-full', 'opacity-100')
    dom.fsPanel.classList.add('opened')
    focusableElements.forEach(element => element.removeAttribute('tabindex'))
    setTimeout(() => {
      dom.fsPanelClose.focus()
    }, 50)
  } else {
    dom.fsPanel.classList.add('-z-1', 'opacity-0')
    dom.fsPanel.classList.remove('z-full', 'opacity-100')
    dom.fsPanel.classList.remove('opened')
    focusableElements.forEach(element => element.setAttribute('tabindex', '-1'))
    setTimeout(() => {
      console.log('dom.filterBtn', dom.filterBtn)
      dom.filterBtn.focus()
    }, 50)
  }
}

export const setupCollection = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    privatePrices()
    dom.fsPanel.addEventListener('click', () => {
      toggleFilterPanel(false)
    })
    dom.fsPanel.querySelector('.popup-content')?.addEventListener('click', (e) => {
      e.stopPropagation()
    })

    dom.filterBtn.addEventListener('click', () => {
      toggleFilterPanel()
    })
    dom.filterBtn.addEventListener('keyup', (e) => {
      if(e.key === "Enter") {
        toggleFilterPanel()
      }
    })
    dom.fsPanelClose.addEventListener('click', () => {
      toggleFilterPanel(false)
    })
    window.addEventListener('keyup', (e) => {
      if(e.key === "Escape") {
        toggleFilterPanel(false)
      }
    })

    dom.fsPanelInner.addEventListener("transitionend", e => {
      dom.fsPanelClose.focus()
    })
    setTimeout(() => {
      dom.videos.forEach(video => {
        video.addEventListener('ended', () => {
          video.play()
        })
        video.play()
      })
    }, 300)
    state.facets = dom.facets
    state.clearAll = dom.clearAll
    state.sortOptions = dom.sortOptions
    initFacets()
    initWishlist()
  }

  GTM_plpViewItems(document.querySelectorAll('#product-grid [data-gtm-items-el]:not(.gtm-item_viewed)'));
}
